import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {OrderModel} from '../../order/order.model';
import {LinkComponent} from "../../buttons/link/link.component";
import {TranslateModule} from '@ngx-translate/core';
import {ConfigurationModel} from '../../configuration/configuration.model';

@Component({
    selector: "woa-order-heading-panel",
    templateUrl: "order-heading-panel.component.html",
    styleUrl: "./order-heading-panel.component.scss",
    imports: [
        LinkComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class OrderHeadingPanelComponent {
    public orderModel: OrderModel = inject(OrderModel);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);
}
